import React from 'react';
import TextField from '@mui/material/TextField';

export default ({
  rows,
  type,
  value,
  label,
  style,
  margin,
  classes,
  disabled,
  onChange,
  inputRef,
  fullWidth,
  onKeyDown,
  className,
  multiline,
  InputProps,
  placeholder,
}) => (
  <TextField
    type={type}
    minRows={rows}
    label={label}
    style={style}
    value={value}
    classes={classes}
    disabled={disabled}
    onChange={onChange}
    inputRef={inputRef}
    onKeyDown={onKeyDown}
    fullWidth={fullWidth}
    multiline={multiline}
    className={className}
    InputProps={InputProps}
    placeholder={placeholder}
    margin={margin || 'normal'}
  />
);
